// Google Analytics (GA4) via `react-ga4`. `react-ga4` injects its own gtag
// loader, so index.html carries no analytics script.

import ReactGA from 'react-ga4';

export const GA_MEASUREMENT_ID = 'G-XBVC2MBN1M';

let started = false;

/** Load GA4 once. SPA page views are sent manually from the router (see App.tsx). */
export function initAnalytics(): void {
  if (started) return;
  started = true;
  ReactGA.initialize(GA_MEASUREMENT_ID, {
    gtagOptions: { send_page_view: false },
  });
}

/** Send a SPA page view for the given path (called on every route change). */
export function trackPageView(path: string): void {
  ReactGA.send({ hitType: 'pageview', page: path, title: document.title });
}

/**
 * Send a custom event. Signature matches the Angular `GoogleAnalyticsService.event`
 * calls the inquiries form used: `event(action, category, label)`.
 *
 * Uses `react-ga4`'s GA4-native string form on purpose - the object form runs the
 * name/category/label through a title-caser (`submit_success` -> `Submit_success`).
 */
export function trackEvent(action: string, category?: string, label?: string): void {
  ReactGA.event(action, {
    ...(category ? { event_category: category } : {}),
    ...(label ? { event_label: label } : {}),
  });
}
